import { tags } from '../tagNames';
import { useUserTags } from '../useUserTags';

export const useHasSuggestedText = () => {
	const { userTags, isSuccess } = useUserTags();

	return isSuccess ? userTags.includes(tags.suggestedTexts) : null;
};
